import type { PropsWithChildren } from "react";

import loadingSvg from "./loading.svg";

export const TabularLoading = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex flex-col h-full w-full items-center justify-center gap-2">
      <img src={loadingSvg} alt="loading" width={100} height={100} />
      {children}
    </div>
  );
};
